module.exports = __webpack_public_path__ + "img/cancer-symposium-banner.9b7870ce.png";